<template>
  <div id="intro-3" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Congratulations!</h3>
      </div>

      <div class="intro-box__content">
        <p>You have finished configuring the app. Click Start Exploring to start using the app.</p>

        <p>Your orders will now sync. You will see a progress bar at the top of the screen
          while the sync is in effect. Calculations may not be accurate until the sync is
          complete.</p>

        <p>If you need any help please review our help dashboard by clicking the
          <i class="fa-question-circle fas"></i> icon in the navigation. If you still have questions
          or your commissions are not calculating properly please feel free to reach out to us.</p>
      </div>
    </div>

    <div class="intro-box__footer">
      <button class="button--wide" @click="finished">Start Exploring</button>

      <div style="padding: 10px 0;"><a href="https://calendly.com/support-visceral/onboarding" target="_blank">Need help with getting setup?</a></div>
    </div>

    <div class="intro-box__pagination">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span class="active"></span>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [
    client
  ],
  methods: {
    async startDataSync () {
      this.$store.state.settings.sync_active = true

      this.request('get', '/shop-sync/', {
        domain: this.$store.state.shop.myshopify_domain,
        app_slug: 'vendor-consignment'
      }).then(response => {
        let checkProgress = setInterval(() => {
          this.request('get', '/sync-progress/', {
            domain: this.$store.state.shop.myshopify_domain
          }).then(response => {
            let label = document.getElementById('progress-bar-label')
            let bar = document.getElementById('progress-bar-progress')

            if (response.description != null) {
              if (response.description.length > 0) {
                label.textContent = response.description + '...'
              }

              bar.style.width = response.progress + '%'
            } else {
              label.textContent = 'Syncing...'
            }

            if (!response.active) {
              this.$store.state.settings.sync_active = false
              clearInterval(checkProgress)

              label.textContent = 'Syncing...'
              bar.style.width = 0
            }
          })
        }, 1000)
      })
    },
    finished () {
      this.startDataSync()
      this.$emit('finished')
    }
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step8.vue